export const ICON_INTERNAL = 'fi_arrow-right';
export const ICON_EXTERNAL = 'fi_arrow-right-1';
export const ICON_OVERLAY = 'fi_plus-circle';
export const ICON_PHONE = 'fi_phone';
export const ICON_MAIL = 'fi_mail';
export const ICON_LINKEDIN = 'fi_linkedin';
export const ICON_YOUTUBE = 'fi_youtube';
export const ICON_INSTAGRAM = 'fi_instagram';
export const ICON_FACEBOOK = 'fi_facebook';
export const ICON_VIMEO = 'vimeo';
export const ICON_XING = 'xing';
